<script setup lang="ts">
import IconBase from '../IconBase.vue';
</script>

<template>
  <IconBase>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="halfStar" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="50%" style="stop-color: currentColor; stop-opacity: 1" />
          <stop offset="50%" style="stop-color: #dfe1e6; stop-opacity: 1" />
        </linearGradient>
      </defs>
      <path
        d="M12 2L15.09 8.26L22 9L16.91 15.74L18.18 22.02L12 18.77L5.82 22.02L7.09 15.74L2 9L8.91 8.26L12 2Z"
        fill="url(#halfStar)"
      />
    </svg>
  </IconBase>
</template>
